export const isValidValue = (value: any): boolean => {
    return value !== null && value !== undefined && value !== '' && value !== 0;
};
